/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import React, { useState, useEffect } from 'react';
import './LoadingSpinner.css';

const LoadingSpinner: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate progress from 0 to ~70%
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 70) {
          clearInterval(progressInterval);
          return 70;
        }
        return prev + 0.5;
      });
    }, 50);

    return () => {
      clearInterval(progressInterval);
    };
  }, []);

  return (
    <div className="loading-container">
      <div className="loading-content">
        {/* Logo with Brain Icon */}
        <div className="logo-wrapper">
          <div className="logo-circle">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Brain icon - interconnected nodes network */}
              <circle cx="20" cy="20" r="4" fill="#3388FF"/>
              <circle cx="44" cy="20" r="4" fill="#3388FF"/>
              <circle cx="32" cy="32" r="5" fill="#3388FF"/>
              <circle cx="20" cy="44" r="3.5" fill="#3388FF"/>
              <circle cx="44" cy="44" r="3.5" fill="#3388FF"/>
              <circle cx="15" cy="32" r="3" fill="#3388FF"/>
              <circle cx="49" cy="32" r="3" fill="#3388FF"/>
              <circle cx="32" cy="18" r="3" fill="#3388FF"/>
              <circle cx="32" cy="46" r="3" fill="#3388FF"/>
              {/* Connecting lines */}
              <line x1="20" y1="20" x2="32" y2="32" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="44" y1="20" x2="32" y2="32" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="32" y1="32" x2="20" y2="44" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="32" y1="32" x2="44" y2="44" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="15" y1="32" x2="32" y2="32" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="49" y1="32" x2="32" y2="32" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="32" y1="18" x2="32" y2="32" stroke="#3388FF" strokeWidth="1.5"/>
              <line x1="32" y1="46" x2="32" y2="32" stroke="#3388FF" strokeWidth="1.5"/>
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="loading-title">Vernika AI</h1>

        {/* Loading Status Messages */}
        <div className="loading-messages">
          <p className="loading-message-primary">Preparing your Vernika AI experience...</p>
          <p className="loading-message-secondary">Analyzing today's call schedule...</p>
        </div>

        {/* Progress Bar */}
        <div className="progress-bar-container">
          <div className="progress-bar-track">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        {/* Tip Message */}
        <p className="loading-tip">
          Tip: You can integrate your calendar to automatically sync meetings
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
